import request from '../common/request.js';

//获取中英文对照列表
export function GetTranslationList(payload) {
    return request.post('/sys/GetTranslationList', payload);
}

//新增中英文对照列表
export function AddTranslationList(payload) {
    return request.post('/sys/AddTranslationList', payload);
}

//更新中英文对照列表
export function UpdateFieldTranslation(payload) {
    return request.post('/sys/UpdateFieldTranslation', payload);
}

//删除中英文对照列表
export function DeleteFieldTranslation(payload) {
    return request.post('/sys/DeleteFieldTranslation', payload);
}